// Opciones de los selects del modal de solicitud de contacto scout → atleta.
// Centralizadas acá para reusarlas en el modal y en cualquier validación futura.

export const OPPORTUNITY_TYPES = [
  "Prueba deportiva",
  "Beca académica-deportiva",
  "Contrato profesional",
  "Patrocinio",
  "Otro",
];

export const LOCATION_OPTIONS = [
  "Colombia",
  "México",
  "Argentina",
  "Chile",
  "Perú",
  "Brasil",
  "Ecuador",
  "Uruguay",
  "Estados Unidos",
  "España",
  "Otro",
];
